import React, { useState, useEffect } from "react";
import { Container, Col, Spinner, Card, Button, Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import hubspotLogo from "../assets/images/hubspotLogo.svg";
import arrowIcon from "../assets/images/icondoublearrows.png";
import tripletexLogo from "../assets/images/tripletexLogo.png";

import { getUrl } from "../helpers/getUrl";
import { fetchStatus } from "../store/slices/preferenceSlice";

import {
  onSetTxToken,
  onSetConnectionPreference,
  setShowErrorModal,
  setShowSuccessModal,
} from "../store/slices/preferenceSlice";

import axios from "axios";

import CmsEditAndSave from "../helpers/CmsEditAndSave";
import { CmsConstructor } from "../helpers/CmsConstructor";
import { useCmsHook } from "../helpers/cmsHook";
import { Loading } from "../components/Loading";

function ConnectTripletex() {
  const { cmsInstance, isEdit, setCmsInstance } = useCmsHook();

  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [disConnectLoading, setDisConnectLoading] = useState(false);
  const [connectLoading, setConnectLoading] = useState(false);

  const { isTripletexConnected, txToken } = useSelector(
    (state) => state.preference
  );

  const onConnectTripletex = async () => {
    try {
      setConnectLoading(true);
      const portalId = searchParams.get("portalId");
      const userId = searchParams.get("userId");
      await axios.post(getUrl("REACT_APP_CONNECT_TRIPLETEX"), {
        portalId,
        userId,
        token: txToken,
      });

      dispatch(onSetConnectionPreference({ connection: true }));

      dispatch(
        setShowSuccessModal({
          message:
            "cmsContent.notifications.authenticationPage.successContent.connectAcc.message",
        })
      );
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      console.log(errorMessage);
      dispatch(setShowErrorModal({ message: errorMessage }));
    } finally {
      setConnectLoading(false);
    }
  };

  const onDisconnectTripletex = async () => {
    try {
      setDisConnectLoading(true);
      const portalId = searchParams.get("portalId");
      await axios.post(getUrl("REACT_APP_REMOVE_TX_CREDS"), {
        portalId,
      });
      dispatch(onSetConnectionPreference({ connection: false }));
      dispatch(
        setShowSuccessModal({
          message:
            "cmsContent.notifications.authenticationPage.successContent.disconnectAcc.message",
        })
      );
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      console.log(errorMessage);
      dispatch(setShowErrorModal({ message: errorMessage }));
    } finally {
      setDisConnectLoading(false);
    }
  };

  useEffect(() => {
    const portalId = searchParams.get("portalId");
    if (portalId) {
      dispatch(fetchStatus(portalId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/connect") {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor(dispatch);
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {window.location.pathname === "/connect" && (
        <div className="mt-4 d-flex justify-content-center">
          <CmsEditAndSave />
        </div>
      )}
      <Container
        className="tx-connect-container"
        style={{
          minHeight: `${window.location.pathname !== "/setup" && "100vh"}`,
        }}
      >
        {!cmsInstance ? (
          <Loading />
        ) : (
          <Col
            lg={7}
            className="d-flex flex-column justify-content-center align-items-center h-100"
            style={{
              marginTop: `${
                (window.location.pathname === "/setup" ||
                  window.location.pathname === "/connect") &&
                isEdit
                  ? "650px"
                  : "40px"
              }`,
            }}
          >
            <Card className="tx-connect-card my-auto">
              <Card.Body className="tx-card-body d-flex flex-column justify-content-center align-items-center">
                <div className="mt-4">
                  {cmsInstance &&
                    cmsInstance.showRichText(
                      "cmsContent.authenticationPage.heading"
                    )}
                </div>
                <div className="d-flex flex-row align-items-center my-5">
                  <Card.Img
                    src={tripletexLogo}
                    alt="tripletex logo"
                    bsPrefix="tx-logo"
                    style={{ width: "72px" }}
                  />
                  <Card.Img
                    src={arrowIcon}
                    alt="arrow"
                    bsPrefix="arrow-icon"
                    className="mx-5 my-auto"
                    style={{ width: "30px" }}
                  />
                  <Card.Img
                    src={hubspotLogo}
                    alt="hubspot logo"
                    bsPrefix="hubspot-logo"
                    style={{ width: "72px" }}
                  />
                </div>
                <div className="w-75">
                  {cmsInstance &&
                    cmsInstance.showRichText(
                      "cmsContent.authenticationPage.description1"
                    )}
                  {isTripletexConnected &&
                    cmsInstance &&
                    cmsInstance.showRichText(
                      "cmsContent.authenticationPage.description2.connected"
                    )}
                  {!isTripletexConnected &&
                    cmsInstance &&
                    cmsInstance.showRichText(
                      "cmsContent.authenticationPage.description2.disConnected",
                      "authentication"
                    )}
                </div>
                {!isTripletexConnected && (
                  <Form.Control
                    type="text"
                    placeholder="enter token"
                    size="sm"
                    onChange={(e) =>
                      dispatch(onSetTxToken({ token: e.target.value }))
                    }
                    value={txToken}
                    disabled={isTripletexConnected}
                    style={{
                      cursor: `${isTripletexConnected && "not-allowed"}`,
                      width: "75%",
                    }}
                  />
                )}
                <div className="mt-2 d-flex flex-row align-items-center mt-3">
                  <Button
                    className={
                      "tx-card-button px-3 " +
                      (isTripletexConnected && "tx-connected-card-button")
                    }
                    disabled={isTripletexConnected || !txToken}
                    onClick={onConnectTripletex}
                  >
                    {connectLoading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <span>
                        {isTripletexConnected
                          ? "Tripletex is connected"
                          : "Connect Tripletex"}
                      </span>
                    )}
                  </Button>
                  {isTripletexConnected && (
                    <Button
                      className="tx-card-disconnect-button ms-2"
                      onClick={onDisconnectTripletex}
                    >
                      {disConnectLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <span>Disconnect Tripletex</span>
                      )}
                    </Button>
                  )}
                </div>
                <div className="w-75 mt-4">
                  {cmsInstance &&
                    cmsInstance.showRichText(
                      "cmsContent.authenticationPage.description3"
                    )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Container>
    </div>
  );
}

export default ConnectTripletex;
